export function handle(type, data) {
  switch (type) {
    case 'action:next':
      // data: { questNum, ... }
      break;
    case 'state:change':
      // data: { state, ... }  ex: 'intro' | 'question' | 'result'
      break;
  }
}
